import api from '../../../services/api'
import React, { useEffect, useState, useCallback } from 'react';

const OptionsRemote = ({ service, method, params, path, display, value, onFetchOptions }) => {

    const [options, setOptions] = useState([]);

    const fetchOptions = useCallback( async () => {
      let promisse = null;
      let client = await api(service);

      if (method.toUpperCase() === "POST") {
          promisse = client.post(path, params);
      } else {
          promisse = client.get(path, {params});
      }

      promisse.then(res => {
          setOptions(res.data)
          !!onFetchOptions && onFetchOptions(res.data);
      });
  },[method,onFetchOptions,params,path,service])

    const propValue = (item) => {
        return value ?
            item[value] :
            item.value;
    }

    const displayFormat = (item) => {
            if(display) {
                let text = display;
                Object.keys(item).forEach(prop => {
                    let exp = new RegExp(`{${prop}}`, "g");
                    text = text.replace(exp, item[prop])
                })
                return text
            }
            return item.text
    }
    useEffect(() => {
        fetchOptions()
    }, [fetchOptions]);

    return (
        <React.Fragment>
            {
                options.map(item =>
                    <option value={propValue(item)} key={propValue(item)}>
                        {displayFormat(item)}
                    </option>
                )
            }
        </React.Fragment>
    )
};

export default OptionsRemote;
